import StyledLink from '../StyledLink'
import {
  MONITOR,
  RUNNER
} from '../routes'
import type { Props } from '../types'

const base = '/' + MONITOR + '/' + RUNNER

const LinkToMonitorRunner = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={base}
  >
    {children}
  </StyledLink>

export default LinkToMonitorRunner
